<template>
    <div>

            <div class="overflowRightNav">
                <Row style="padding-bottom: 30px">
                    <Col span="5">
                        <DatePicker
                                split-panels
                                type="daterange"
                                :options="options"
                                :placement="bottom"
                                :size="small"
                                placeholder="选择日期"
                                @on-change="handleOk"
                                :value="valuedate"
                               >
                        </DatePicker>
                    </Col>
                </Row>
                <Card  class="staff_item" v-for="(item, index) in pageData" :key="index">
                    <p slot="title"><Icon type="ios-ribbon-outline" size="20" style="position:relative;top:-3px" />{{item.adminName}}</p>
                    <Row style="padding-bottom: 10px">
                        <Col span="12">销售金额</Col>
                        <Col span="12" align="right" style=" color:#4673e7">{{item.lpriceTotal}}</Col>
                    </Row>
                    <Row>
                        <Col span="12">所属门店</Col>
                        <Col span="12" align="right">{{item.shopName}}</Col>
                    </Row>
                </Card>
            </div>

    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                cid: "",
                page:1,
                rows:10,
                pageData:[],
                options: {
                    shortcuts: [
                        {
                            text: '过去一周',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            },

                        },
                        {
                            text: '过去一月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            },

                        },
                        {
                            text: '过去三月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            },

                        }
                    ],
                }
            }
        },
        mounted: function () {
            //DOM更新完后再请求数据
            this.$nextTick(function () {


            });
        },
        created: function () {
            //DOM更新完之前请求数据
            let data= JSON.parse(localStorage.getItem('adminUser'))
            this.cid=data.cid

            this.valuedate[0] = this.nowTime
            this.valuedate[1] = this.nowTime
            this.getPerformanceList(this.cid,this.valuedate[0],this.valuedate[1],this.page,this.rows)
        },
        methods: {
            getPerformanceList(cid,beantime,endtime,page,rows){
                this.$Api.getPerformanceList({
                    cid: cid,
                    beantime: beantime,
                    endtime: endtime,
                    page: page,
                    rows: rows,
                    status: 0,
                    state: 1,
                }).then(res => {
                    if(res.code==200){

                        this.pageData = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
             handleOk(data){
                 this.getPerformanceList(this.cid,data[0],data[1],this.page,this.rows)
            }

        }
    }
</script>


<style lang="scss" scoped>
    .server-title {
        display: inline-block;
        text-align: center;
        width: 88%
    }

.staff_item{
    box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.14);
    margin-bottom: 25px;
    width: 360px;
    float: left;
}

</style>